// extracted by mini-css-extract-plugin
export default {"copyright":"Footer_copyright__4JZ8K"};